import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	sendResetPassword
} from '../../../actions';

import Button from '@material-ui/core/Button';
import ForwardICon from '@material-ui/icons/Forward';
import TextField from '@material-ui/core/TextField';
import classNames from 'classnames';
import PropTypes from "prop-types";

const styles = theme => ({
	loginMainBox:{
		height:'85% !important',
		maxWidth:'650px !important',
		maxHeight:750
	},
	singInButton: {
		marginRight: theme.spacing.unit,
	},
	textField:{
		width:'100%',
		marginBottom:15
	},
	explainText:{
		fontSize:'90%',
		color:'rgba(0,0,0,0.67)',
		padding:10,
		backgroundColor:'rgba(0,0,0,0.05)',
		borderRadius:5,
		marginBottom: 20
	},
	explainTextCautions:{
		color:'rgba(155,0,0,1.00)',
		display:'block',
		borderTop:'rgba(0,0,0,0.3) solid 1px',
		marginTop:7,
		paddingTop:7
	},
	resetFormText:{
		color:'#40bad0',
		cursor:'pointer'
	}
});


class ResetForm extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			inputData : {
				jigyousha_cd : props.jigyousha_cd,
				user_id : props.user_id,
				mail_address:''
			},
			error : {
				jigyousha_cd:'',
				user_id : '',
				mail_address:''
			},
		}
	}


	_onClickSubmit(){
		const {dispatch} = this.props;
		const data = this.state.inputData;
		const jigyousha_cd = String(data.jigyousha_cd).trim();
		const user_id = String(data.user_id).trim();
		const mail_address = String(data.mail_address).trim();

		let {error} = this.state;

		if(!jigyousha_cd || !user_id || !mail_address){
			if(!jigyousha_cd){
				error.jigyousha_cd = "必須入力"
			}
			if(!user_id){
				error.user_id = "必須入力"
			}
			if(!mail_address){
				error.mail_address = "必須入力"
			}
			this.setState({
				error
			});
		}
		else if(error.jigyousha_cd !== '' || error.user_id !== '' || error.mail_address !== ''){

		}
		else{
			dispatch(sendResetPassword({
				jigyousha_cd,
				user_id,
				mail_address,
			}));
		}
	}

	_handleChange(event) {
		let {inputData,error} = this.state;
		if(event.target.value){
			error[event.target.name] = '';
		}
		switch (event.target.name) {
			case 'jigyousha_cd':
				inputData.jigyousha_cd = event.target.value;
				break;
			case 'user_id':
				inputData.user_id = event.target.value;
				break;
			case 'mail_address':
				inputData.mail_address = event.target.value;
				const reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
				if(!reg.test(event.target.value)){
					error[event.target.name] = 'メールアドレスが不正';
				}
				break;
			default:
				break;
		}
		this.setState({
			inputData,
			error
		});
	}

	_handleKeyPress(event){
		if(event.key !== 'Enter'){
			return
		}
		const inputData = this.state.inputData;
		let jigyousha_cd = inputData.jigyousha_cd;
		let user_id = inputData.user_id;
		let mail_address = inputData.mail_address;
		switch (event.target.name) {
			case 'jigyousha_cd':
				this.user_id.focus();
				break;
			case 'user_id':
				this.mail_address.focus();
				break;
			case 'mail_address':
				if(jigyousha_cd && user_id && mail_address){
					this._onClickSubmit();
				}
				else{
					this.jigyousha_cd.focus();
				}
				break;
			default:
				break;
		}
	}

	render () {
		const { classes } = this.props;
		const auth = this.props.auth;
		const err = auth.sendpasswordError;
		const {jigyousha_cd, user_id} = this.state.inputData;

		return (
			<div id="login_area">
				<div className={classNames("login_main_box",classes.loginMainBox)}>
					<h2>パスワード再設定申込フォーム</h2>
					<p className={classes.explainText}>
						事業者コード・ユーザーID・メールアドレスを入力し、送信ボタンを押して下さい。<br />
						入力されたメールアドレスにパスワード再設定用のメールが送信されます。<br />
					</p>
					<TextField
						label="事業者コード"
						placeholder="事業者コード"
						className={classes.textField}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						name="jigyousha_cd"
						autoFocus={true}
						inputRef={field => this.jigyousha_cd = field}
						inputProps={{
							maxLength:10
						}}
						value={jigyousha_cd}
						error={Boolean(this.state.error.jigyousha_cd)}
						helperText={this.state.error.jigyousha_cd}
					/>
					<TextField
						label="ユーザーID"
						placeholder="ユーザーID"
						className={classes.textField}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						name="user_id"
						inputRef={field => this.user_id = field}
						inputProps={{
							maxLength:20
						}}
						error={Boolean(this.state.error.user_id)}
						helperText={this.state.error.user_id}
						value={user_id}
					/>
					<TextField
						label="メールアドレス"
						placeholder="メールアドレス"
						className={classes.textField}
						onKeyPress={this._handleKeyPress.bind(this)}
						onChange={this._handleChange.bind(this)}
						name="mail_address"
						inputRef={field => this.mail_address = field}
						inputProps={{
							maxLength:150
						}}
						error={Boolean(this.state.error.mail_address)}
						helperText={this.state.error.mail_address}
					/>
					<div className="btn_area clearfix">
						<div className={"fl_left"}>
							<p
								className={classes.resetFormText}
								onClick={this.props.backLoginFunc}
							>
								ログイン画面へ戻る
							</p>
						</div>
						<Button variant="contained" color="primary" className="fl_right" onClick={this._onClickSubmit.bind(this)}>
							<ForwardICon className={classes.singInButton} />
							送信
						</Button>
					</div>
					{err &&
					<div className="caution_area">
						<i className="fa fa-exclamation-triangle" aria-hidden="true" />
						<p>{err}</p>
					</div>
					}

					<p className="copyright fsm5 ta_center">TSUNAGUTE</p>
				</div>
			</div>
		);
	}
}

ResetForm.propTypes = {
	backLoginFunc:PropTypes.func,
	jigyousha_cd:PropTypes.string,
	user_id:PropTypes.string,
};

function mapStateToProps(state) {
	return {
		auth: state.auth
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(ResetForm);



// WEBPACK FOOTER //
// ./src/routes/menu/components/reset-form.js